// extracted by mini-css-extract-plugin
export var infoRow = "_r5-2";
export var labelContainer = "_r5-0";
export var rightInfo = "_r5-1";